import { NavLink, Outlet, useNavigate, Navigate } from "react-router-dom";
import { LayoutDashboard, FileText, Image, MessageSquareQuote, Building2, Newspaper, LogOut, ExternalLink, UtensilsCrossed, ImageUp, ArrowLeftRight, Scale } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const LINKS = [
  { to: "/admin/demandes", label: "Demandes de devis", icon: LayoutDashboard },
  { to: "/admin/contenu", label: "Contenu du site", icon: FileText },
  { to: "/admin/images", label: "Images du site", icon: ImageUp },
  { to: "/admin/documents-legaux", label: "Documents légaux", icon: Scale },
  { to: "/admin/transfert", label: "Transfert de contenu", icon: ArrowLeftRight },
  { to: "/admin/medias", label: "Galerie & médias", icon: Image },
  { to: "/admin/menus", label: "Menus & cartes", icon: UtensilsCrossed },
  { to: "/admin/temoignages", label: "Témoignages", icon: MessageSquareQuote },
  { to: "/admin/references", label: "Références clients", icon: Building2 },
  { to: "/admin/blog", label: "Le Journal (blog)", icon: Newspaper },
];

export function RequireAuth({ children }) {
  const { user, checked } = useAuth();
  if (!checked || user === null) return <div className="flex min-h-screen items-center justify-center bg-[#FAF6EF] text-[#2C2C2C]/60">Chargement…</div>;
  if (!user) return <Navigate to="/admin" replace />;
  return children;
}

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = () => { logout(); navigate("/admin"); };

  return (
    <div className="flex min-h-screen bg-[#FAF6EF]" data-testid="admin-layout">
      <aside className="flex w-64 shrink-0 flex-col border-r border-[#2C2C2C]/10 bg-white">
        <div className="border-b border-[#2C2C2C]/10 p-6">
          <img src="/afroregal-logo.webp" alt="Afro Regal" className="h-12 w-auto" />
          <p className="mt-1 text-xs uppercase tracking-[0.2em] text-[#C9A84C]">Administration</p>
        </div>
        <nav className="flex-1 space-y-1 p-3">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`admin-nav-${l.to.split("/").pop()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm transition-colors ${
                  isActive ? "bg-[#2C2C2C] text-white" : "text-[#2C2C2C]/75 hover:bg-[#FAF6EF]"
                }`
              }
            >
              <l.icon size={17} /> {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-[#2C2C2C]/10 p-3">
          <a href="/" target="_blank" rel="noreferrer" className="mb-1 flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm text-[#2C2C2C]/75 hover:bg-[#FAF6EF]"><ExternalLink size={17} /> Voir le site</a>
          <button onClick={doLogout} data-testid="admin-logout" className="flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-sm text-red-700 hover:bg-red-50"><LogOut size={17} /> Déconnexion</button>
        </div>
      </aside>
      <div className="flex-1">
        <header className="flex items-center justify-between border-b border-[#2C2C2C]/10 bg-white px-8 py-4">
          <span className="text-sm text-[#2C2C2C]/60">Bonjour, <strong className="text-[#2C2C2C]">{user?.name || "Admin"}</strong></span>
        </header>
        <main className="p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
